export const OPTIONS_TOGGLE = 'User/optionsToggle';
